/// <amd-module name="SuiteCommerce.ShippingBar.HeaderShippingBar.View"/>
define("SuiteCommerce.ShippingBar.HeaderShippingBar.View", ["require", "exports", "Backbone", "SuiteCommerce.ShippingBar.HeaderShippingBar.Text.View", "suitecommerce_shippingbar_header.tpl", "SuiteCommerce.ShippingBar.Common.Utils", "underscore", "jQuery", "SuiteCommerce.ShippingBar.Instrumentation", "SuiteCommerce.ShippingBar.Common.Cookies"], function (require, exports, Backbone_1, HeaderText_View_1, suitecommerce_shippingbar_header_tpl, Utils_1, _, jQuery, Instrumentation_1, Cookies_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.ShippingBarHeaderView = Backbone_1.View.extend({
        template: suitecommerce_shippingbar_header_tpl,
        title: Utils_1.Utils.translate('sc-shippingbar-header'),
        events: {
            'click [data-action = "close-shipping-bar"]': 'hideShippingBar',
            'click [data-action = "next-text"]': 'showNextMessage',
            'click [data-action = "previous-text"]': 'showPreviousMessage',
        },
        initialize: function (options) {
            var _this = this;
            var model = options.model;
            model.on('cartAmount:changed', function () {
                _this.render();
            });
            model.on('pdpAmount:changed', function () {
                if (_this.model.get('cartAmount')) {
                    _this.render();
                }
            });
            this.headerText = new HeaderText_View_1.HeaderText({
                model: this.model,
            });
            window.addEventListener('focus', this.render());
            this.render();
        },
        render: function () {
            var _this = this;
            _.defer(function () {
                var $textElement = _this.$('.sc-shippingbar-text-message-ref-for-height');
                var textHeight = 0;
                $textElement.each(function () {
                    var nextHeight = jQuery(this).height();
                    if (nextHeight > textHeight) {
                        textHeight = nextHeight;
                    }
                });
                _this.$('.sc-shippingbar-message').addClass('sc-shippingbar-header-remove-text');
                _this.$('.sc-shippingbar-message').addClass('sc-shippingbar-header-hide-text');
                _this.$('.sc-shippingbar-header-text-active').removeClass('sc-shippingbar-header-remove-text');
                _this.$('.sc-shippingbar-header-text-active').removeClass('sc-shippingbar-header-hide-text');
                _this.$('.sc-shippingbar-header-text-center').height(textHeight);
                _this.$('.sc-shippingbar-header-text').height(textHeight);
                _this.$('.sc-shippingbar-header-chevron-container').css('padding-top', (textHeight - 13) / 2 + "px");
                _this.$('.sc-shippingbar-header-close-container').css('line-height', textHeight + "px");
            });
            this._render();
        },
        getContext: function () {
            var currentValue = this.model.get('cartAmount');
            this.model.updateCurrencyConfiguration();
            this.messagesList = [this.model.getMessage('headerInitialMessage', 0),
                this.model.getMessage('headerMessageAlt1', 0),
                this.model.getMessage('headerMessageAlt2', 0)].filter(function (message) {
                return message !== (undefined || '');
            });
            var cookies = Cookies_1.default.getInstance();
            var isOpen = cookies.get('isOpen');
            if (isOpen === 'false')
                isOpen = false;
            var haveLink = !(this.model.attributes.barUrlLink === '');
            var shippingGoalAvailable = this.model.attributes.shippingAmount <= currentValue;
            var isInProgress = 0 < currentValue;
            var headerProgressMessage = this.model.getMessage('headerProgressMessage', currentValue);
            var headerCongratsMessage = this.model.get('headerCongratsMessage');
            var multipleMessages = this.messagesList.length > 1 && !isInProgress;
            if (isOpen === undefined || isOpen === null) {
                isOpen = true;
            }
            if (isOpen) {
                if (shippingGoalAvailable) {
                    clearInterval(this.barInterval);
                    isOpen = !!headerCongratsMessage;
                }
                else if (isInProgress) {
                    clearInterval(this.barInterval);
                    isOpen = !!headerProgressMessage;
                }
                else
                    isOpen = true;
            }
            if (multipleMessages) {
                this.setAutomaticChange();
            }
            return {
                shippingGoalAvailable: shippingGoalAvailable,
                isInProgress: isInProgress,
                headerCongratsMessage: headerCongratsMessage,
                headerProgressMessage: headerProgressMessage,
                haveLink: haveLink,
                multipleMessages: multipleMessages,
                currentMessageIndex: this.model.get('headerMessageIndex'),
                urlLink: this.model.attributes.barUrlLink,
                shippingBarOpen: isOpen,
                isFloating: this.options.isFloating,
            };
        },
        childViews: {
            'ShippingBar.Header.Text': function addChildView() {
                return this.headerText;
            },
        },
        setAutomaticChange: function () {
            var _this = this;
            clearInterval(this.barInterval);
            this.barInterval = setInterval(function () {
                _this.getHeaderMessage('next');
            }, 5000);
        },
        hideShippingBar: function () {
            var cookies = Cookies_1.default.getInstance();
            cookies.set('isOpen', false);
            this.logCloseBar();
            this.render();
        },
        showPreviousMessage: function () {
            this.getHeaderMessage('prev');
            this.logMessageChange();
            this.setAutomaticChange();
        },
        showNextMessage: function () {
            this.getHeaderMessage('next');
            this.logMessageChange();
            this.setAutomaticChange();
        },
        getHeaderMessage: function (direction) {
            if (!this.transitionActive) {
                this.transitionActive = true;
                var nextIndex = this.getNextPosition(this.model.get('headerMessageIndex'), this.messagesList.length, direction);
                this.changeBackground(this.model.get('headerMessageIndex'), nextIndex);
                this.model.set('headerMessageIndex', nextIndex);
                this.changeMessageText();
            }
        },
        changeBackground: function (prevNumber, nextNumber) {
            // tslint:disable-next-line:max-line-length
            jQuery(".sc-shippingbar-header-background-initial-" + prevNumber).removeClass("sc-shippingbar-header-background-initial-" + prevNumber);
            jQuery('.sc-shippingbar-header-background-transition-base').addClass("sc-shippingbar-header-background-initial-" + nextNumber);
        },
        changeMessageText: function () {
            var _this = this;
            var messageIndex = this.model.get('headerMessageIndex');
            var activeText = this.$('.sc-shippingbar-header-text-active');
            var textToSetActive = this.$(".shippingbar-text-" + messageIndex);
            activeText.removeClass('sc-shippingbar-header-text-active');
            var animation = this.toggleVisibility(activeText);
            animation.done(function () {
                textToSetActive.addClass('sc-shippingbar-header-text-active');
                _this.toggleVisibility(textToSetActive);
            });
        },
        toggleVisibility: function (element) {
            var _this = this;
            var animationFinished = jQuery.Deferred();
            if (element.hasClass('sc-shippingbar-header-text-active')) {
                element.removeClass('sc-shippingbar-header-remove-text');
                _.defer(function () {
                    element.removeClass('sc-shippingbar-header-hide-text');
                });
            }
            else {
                element.one('transitionend', function (e) {
                    element.addClass('sc-shippingbar-header-remove-text');
                    setTimeout(function () {
                        _this.transitionActive = false;
                    }, 500);
                    animationFinished.resolve();
                });
                element.addClass('sc-shippingbar-header-hide-text');
                return animationFinished;
            }
        },
        getNextPosition: function (idx, length, direction) {
            if (idx === void 0) { idx = 0; }
            switch (direction) {
                case 'next': return (idx + 1) % length;
                case 'prev': return (idx === 0) && length - 1 || idx - 1;
                default: return idx;
            }
        },
        logCloseBar: function () {
            var log = Instrumentation_1.default.getLog('usage');
            log.setParameters({
                activity: 'shipping bar closed',
            });
            log.submit();
        },
        logMessageChange: function () {
            var log = Instrumentation_1.default.getLog('usage');
            log.setParameters({
                activity: 'message force change',
            });
            log.submit();
        },
    });
});
